// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerWriteConn = void 0;
const ledger_1 = require("./..");
const readconn_1 = require("./readconn");
const tokenmanager_1 = require("./tokenmanager");
class LedgerWriteConn extends readconn_1.LedgerReadConn {
    constructor(contract, tokenCache) {
        super(contract, tokenCache);
        this.signer = contract.signer;
    }
    async withdraw(exitProof) {
        return {
            stages: this.call([
                [
                    "withdraw",
                    (_) => {
                        const [balance, sig] = exitProof.toEthProof();
                        return this.contract.withdraw(balance, sig);
                    },
                ],
            ]),
            numStages: 1,
        };
    }
    async deposit(assets) {
        const calls = [];
        if (!assets.values.size)
            throw new Error("attempting to deposit nothing");
        for (const [tokenAddr, asset] of assets.values) {
            const ttype = await this.tokenCache.tokenTypeOf(this.contract, tokenAddr);
            const holder = await this.tokenCache.tokenHolderFor(this.contract, ttype);
            const depositCalls = tokenmanager_1.depositors.get(ttype)(this.signer, ledger_1.Address.fromString(holder), ledger_1.Address.fromString(tokenAddr), asset);
            calls.push(...depositCalls);
        }
        return { stages: this.call(calls), numStages: calls.length };
    }
    async *call(calls) {
        if (calls.length == 0)
            throw new Error("0 calls");
        let nonce = await this.signer.getTransactionCount();
        for (const [name, call] of calls) {
            yield (async () => {
                try {
                    const ctx = await call({ nonce: nonce++ });
                    return [name, ctx];
                }
                catch (e) {
                    throw "message" in e ? new Error(e.message) : new Error(e);
                }
            })();
        }
    }
}
exports.LedgerWriteConn = LedgerWriteConn;
//# sourceMappingURL=writeconn.js.map